import service from "../util/http";
// 质量升级列表
export const getUpgradeOrderList = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/list",
    method: "post",
    data,
  });
};

// 质量升级详情
export const getUpgradeOrderDetail = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/detail",
    method: "post",
    data,
  });
};

// VIN处理列表
export const getVinHandleList = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/vinHandleList",
    method: "post",
    data,
  });
};
// 设置VIN为已完成
export const getVinComplete = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/vinComplete",
    method: "post",
    data,
  });
};
// 删除完成附件
export const getVinDeleteFile = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/vin/deleteFile",
    method: "post",
    data,
  });
};
// 上传完成附件
// export const getVinUploadFile = "/customer/vehicle/upgrade/order/vin/uploadFile"

export const getVinSaveFile = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/vin/saveFiles",
    method: "post",
    data,
  });
}
// VIN升级-下载VIN批量导入模板
export const downloadVinTemplate = () => {
  return service({
    url: "/customer/vehicle/upgrade/order/downloadVinImportTemplate",
    method: "get",
    responseType: "blob"
  })
}
// VIN升级-VIN批量导入匹配
export const downloadVinImport =(data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/vinImport",
    method: "post",
    data,
  })
}
// 前台经销商发起索赔
export const submitUpgradeClaim = (data) => {
  return service({
    url: "/customer/vehicle/upgrade/order/submitClaim",
    method: "post",
    data,
  });
};
